import { Controller } from "@hotwired/stimulus";
import { useClickOutside, useWindowResize } from 'stimulus-use'

export default class extends Controller {
  static targets = ["dialog", "input", "value", "clearcontainer", "addcontainer"]
  static values = {
    input: String
  }

  clickOutside() {
    this.hide()
  }

  top = undefined

  repositionOnScreen = () => {

    let bounding = this.dialogTarget.getBoundingClientRect();
    if (!this.top) {
      this.top = bounding.top
      this.dialogTarget.style.top = `${top}px`
    }

    // Left side is out of viewport, snap to left
    if (bounding.left < 0) {
      this.dialogTarget.classList.add("sm:left-0", "sm:right-auto")
      this.dialogTarget.classList.remove("sm:right-0", "sm:left-auto")
    }

    // Right side is out of viewport, snap to right
    if (bounding.right > (window.innerWidth || document.documentElement.clientWidth)) {
      this.dialogTarget.classList.add("sm:right-0", "sm:left-auto")
      this.dialogTarget.classList.remove("sm:left-0", "sm:right-auto")
    }
  }

  resetPosition = () => {
    this.dialogTarget.classList.remove("sm:left-0", "sm:right-0", "sm:left-auto", "sm:right-auto")
    this.dialogTarget.classList.add("sm:left-0", "sm:right-auto")
  }

  clear = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.inputTargets.forEach((input) => {
      if (input.type !== "hidden" && input.type !== "checkbox") {
        input.value = "";
      }
      if (input.type === "checkbox") {
        input.checked = false
      }
    })

    this.element.querySelector("button").click();
  }

  onChange = (e) => {
    this.inputValue = e.currentTarget.value
  }

  inputValueChanged = (e) => {
    let isCheckbox = false
    let parts = []
    this.inputTargets.forEach((target) => {
      if (target.nodeName === "SELECT") {
        parts.push(target.selectedOptions[0].innerText)
      } else if (target.type === "checkbox") {
        isCheckbox = true

        if (target.checked) {
          parts.push(target.parentElement.querySelector("label")?.innerText.trim())
        }
      } else {
        if (target.value.trim().length > 0) {
          if (target.type === "date") {
            parts.push(target.value.replaceAll(/-/g, "/"))
          } else {
            parts.push(target.value)
          }
        }
      }
    })

    if (isCheckbox) {
      if (parts.length === 1) {
        this.valueTarget.innerText = parts[0]
      } else if (parts.length > 1) {
        this.valueTarget.innerText = parts[0] + ` and ${parts.length - 1} more`
      } else {
        this.valueTarget.innerText = ""
      }
    } else {
      this.valueTarget.innerText = parts.join(" - ")
    }


    if (parts.length === 0) {
      this.clearcontainerTarget.classList.add("hidden")
      this.addcontainerTarget.classList.remove("hidden")
    } else {
      this.clearcontainerTarget.classList.remove("hidden")
      this.addcontainerTarget.classList.add("hidden")
    }
  }

  show = () => {
    this.dialogTarget.classList.remove("hidden");
    setTimeout(() => {
      this.dialogTarget.classList.remove("opacity-0");
    }, 0)
    setTimeout(() => {
      this.dialogTarget.classList.add("opacity-100");
    }, 10)
    this.element.querySelector("input")?.focus()
    this.repositionOnScreen()
  }

  hide = () => {
    this.dialogTarget.classList.add("hidden");
    this.dialogTarget.classList.add("opacity-0");
    this.dialogTarget.classList.remove("opacity-100");
    this.resetPosition()
  }

  toggle = (e) => {
    if (this.dialogTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide()
    }
  }

  resetPosition = () => {
    this.dialogTarget.classList.remove("sm:left-0", "sm:right-0", "sm:left-auto", "sm:right-auto")
    this.dialogTarget.classList.add("sm:left-0", "sm:right-auto")
  }

  windowResize(size) {
    this.resetPosition()
    this.repositionOnScreen()
  }

  connect() {
    useClickOutside(this)
    useWindowResize(this)
    this.repositionOnScreen()

    let inputs = this.element.querySelectorAll("input") || [];
    inputs.forEach((input) => {
      if (input.type === "hidden") {
        // break;
      } else {
        input.dataset.formFilterTarget = "input";
        input.dataset.action = "input->form-filter#onChange";
        this.inputValueChanged()
      }
    })
    let selects = this.element.querySelectorAll("select") || [];
    selects.forEach((input) => {
      input.dataset.formFilterTarget = "input";
      input.dataset.action = "change->form-filter#onChange";
      this.inputValueChanged()
    })

    document.addEventListener("turbo:before-cache", this.hide)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.hide)
  }
}